import { Info } from '../design-system';
import { HIGH_VALUE_DISCLAIMER } from './protection';

export interface HighValueDisclaimerProps {
  className?: string;
}

/**
 * Informational disclaimer shown when a single card in the shipment exceeds
 * the max insurable value ($5,000) — coverage is capped at that amount. Purely
 * informational: no checkbox, never blocks Submit.
 *
 * Colours via `--co-HighValueDisclaimer-*` with hex fallbacks.
 */
export function HighValueDisclaimer({ className = '' }: HighValueDisclaimerProps) {
  return (
    <div
      data-co-component="HighValueDisclaimer"
      role="note"
      className={`flex items-start gap-2.5 rounded-[16px] border p-3 ${className}`.trim()}
      style={{
        background: 'var(--co-HighValueDisclaimer-fill, rgba(255,255,255,0.04))',
        borderColor: 'var(--co-HighValueDisclaimer-border, rgba(255,255,255,0.12))',
      }}
    >
      <span
        aria-hidden
        className="mt-0.5 shrink-0"
        style={{ color: 'var(--co-HighValueDisclaimer-iconColor, rgba(255,255,255,0.55))' }}
      >
        <Info size={18} strokeWidth={1.8} />
      </span>
      <p
        className="text-[13px] leading-[18px]"
        style={{ color: 'var(--co-HighValueDisclaimer-textColor, rgba(255,255,255,0.70))' }}
      >
        {HIGH_VALUE_DISCLAIMER}
      </p>
    </div>
  );
}
